import { create } from "zustand";

interface InfoState {
  storeId: any;
  setStoreId: (storeId: string) => void;
}

export const useAccountOfStore = create<InfoState>((set) => ({
  storeId: undefined,
  setStoreId: (storeId: string) => set(() => ({ storeId })),
}));
